import { useState } from 'react';

import {
  SearchOutlined,
  // CheckCircleFilled,
  // DeleteFilled,
} from '@ant-design/icons';

import { Card, Col, Row, Table, Tag, Input } from 'antd';

import { adminUserHeader as columns } from '@/utils/tableHeader';
import ConfirmModal from '@/components/reusable/modal/confirmModal';

import { customerApiEndpoints } from '@/api/endpoints';
import { handleDeleteApi } from '@/api/crud';
import { useFetch } from '@/hooks';

import { globalSearch } from '@/utils/search/Search';

import GlobalModal from '@/utils/modal/Modal';
import { usePermission } from '@/utils/permissions/userPermission';

/**
 *
 * @returns
 */
const SuperAdminUserActive = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openUserActivateModal, setOpenUserActivateModal] = useState(false);
  const [openUserDeactivateModal, setOpenUserDeactivateModal] = useState(false);
  const [openIsAdminModal, setOpenIsAdminModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const { isAdmin } = usePermission();

  const { data, isLoading, isSuccess, refresh } = useFetch(
    customerApiEndpoints.superAdminActivateUserList,
  );
  const [id, setId] = useState(null);

  const handleCancel = () => {
    setOpen(false);
    setOpenUserActivateModal(false);
    setOpenUserDeactivateModal(false);
    setOpenIsAdminModal(false);
    setId(null);
  };

  const handleOpenActivateModal = (id) => {
    setId(id);
    setOpenUserActivateModal(true);
  };

  const handleOpenDeactivateModal = (id) => {
    setId(id);
    setOpenUserDeactivateModal(true);
  };

  const handleUserActivate = () => {
    handleDeleteApi(
      id,
      customerApiEndpoints.superAdminActive,
      setLoading,
      refresh,
    );
    setOpenUserActivateModal(false);
  };

  const handleDeactivateUserModal = () => {
    handleDeleteApi(
      id,
      customerApiEndpoints.superAdminActive,
      setLoading,
      refresh,
    );
    setOpenUserDeactivateModal(false);
  };

  const handleOk = () => {
    setOpen(false);
  };
  return (
    <>
      <ConfirmModal
        open={open}
        handleOk={handleOk}
        handleCancel={handleCancel}
      />

      {/* <GlobalModal
        isVisible={openIsAdminModal}
        onConfirm={handleToggleIsAdmin}
        onClose={handleCancel}
        type="update"
      /> */}

      <GlobalModal
        isVisible={openUserDeactivateModal}
        onConfirm={handleDeactivateUserModal}
        onClose={handleCancel}
        type="update"
      />

      <GlobalModal
        isVisible={openUserActivateModal}
        onConfirm={handleUserActivate}
        onClose={handleCancel}
        type="update"
      />

      <div className="table">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              variant="outlined"
              extra={
                <div className="flex flex-col items-center justify-center">
                  <Input
                    className="header-search"
                    name="query"
                    placeholder="Search customer..."
                    prefix={<SearchOutlined />}
                    value={searchQuery}
                    onChange={(event) => setSearchQuery(event.target.value)}
                  />
                </div>
              }
            >
              <div className="overflow-x-auto">
                <Table
                  size="small"
                  bordered
                  loading={isLoading || loading}
                  columns={columns}
                  expandable={true}
                  scroll={{ x: true }}
                  className="ant-border-space"
                  pagination={!isLoading ? !!data.length > 10 : false}
                  dataSource={
                    isSuccess
                      ? globalSearch(data, searchQuery)?.map((user, index) => {
                          return {
                            key: user.referenceId,
                            index: index + 1,
                            username: <span>{user.username}</span>,
                            name: (
                              <span>{`${user.firstName} ${user.lastName}`}</span>
                            ),
                            email: <span>{user.email}</span>,
                            mobile: <span>{user.mobileNumber}</span>,

                            status: (
                              <span className=" cursor-pointer">
                                {user.status ? (
                                  <Tag
                                    color="#237804"
                                    className="h-10"
                                    onClick={() =>
                                      handleOpenDeactivateModal(
                                        user?.referenceId,
                                      )
                                    }
                                  >
                                    Active
                                  </Tag>
                                ) : (
                                  <Tag
                                    color="#f5222d"
                                    className="h-10"
                                    onClick={() =>
                                      handleOpenActivateModal(user?.referenceId)
                                    }
                                  >
                                    Inactive
                                  </Tag>
                                )}
                              </span>
                            ),
                          };
                        })
                      : []
                  }
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SuperAdminUserActive;
